<template>
  <footer>
    <p>Copyright 2020 © All rights Reserved Consultancy Squad | <a v-hover :href="/privacy-policy/">Privacy Policy.</a></p>
  </footer>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import "../../assets/styles/breakpoints";
@import '../../assets/styles/variables';
footer {
  background: $sage;
  p {
    font-weight: 100;
    color: lighten($sage, 25%);
    font-size: 0.8rem;
    padding: 10px 0;
    text-align: center;
  }
}
</style>
